exports.sceneAction = [
    {
        _id: '003',
        name: '场景内置行为',
        action_list: [
            {
                name: '标签',
                id: 'scene_001',
                template: 'tag'
            }
        ]
    }
]